'use strict';
/** Cookie有効期限 1年 (秒指定) */
const DEFAULT_EXPIRATION_SECOND = 31536000;

/**
 * キーからCookie情報を取得します。
 * @param {String} key キー
 * @returns Cookie情報 または null
 */
 const getCookieInfoByKey = (key) => {
	if(!key){
		return null;
	}

	const cookie = document.cookie;
	if(!cookie){
		return null;
	}

	const cookieArray = convertCookietoObj(cookie);
	return cookieArray[decodeURIComponent(key)];
}

/**
 * Cookieにキーが存在するかチェックします。
 * @param {String} key キー
 * @returns true=存在する, false=存在しない
 */
 const checkCookie = (key) => {
	if(!key){
		return false;
	}

	const cookie = document.cookie;
	if(!cookie){
		return false;
	}

	const cookieObj = convertCookietoObj(cookie);
	if(key in cookieObj){
		return true;
	}
	return false;
}

/**
 * Cookie情報を連想配列に変換します。
 * @param {String} cookie Cookie
 * @returns Cookie情報の連想配列
 */
 const convertCookietoObj = (cookie) => {
	const cookiesStr = cookie;
	if(!cookiesStr) {
		return;
	}
	let retAaray = {};
	let cookieArray = cookiesStr.split(';');
	for(let i = 0; i < cookieArray.length; ++i){
		let cookie = cookieArray[i].split('=');
		retAaray[cookie[0].trim()] = decodeURIComponent(cookie[1]);
	}
	return retAaray;
}
/**
 * Cookieに書き込みます。
 * @param {String} key キー
 * @param {String} value 値
 * @param {Object} options オプション
 * {
 * 		expires: date(ISO8601), // 指定のない場合はセッションの終了まで (省略可)
 * 		maxAge: date(second), // 期限までの秒数 (省略可)
 * 		domain: 'example.com', // Cookieを送信するドメイン (省略可)
 * 		path: '/' // Cookieを送信するPath (省略可)
 * 		secure: true or false, // https利用の場合のみ使用 (省略可) true: Secure属性を付ける, false: Secure属性を付けない
 * 		httpOnly: true or false, // document.cookieでの値取得を禁止 (省略可) true: HttpOnly属性を付ける, false: HttpOnly属性を付けない
 * 		sameSite: 'strict or lax or none' // 同サイト、別サイトにおけるCookieの扱い (省略可)
 * }
 * 詳細はこちら: https://developer.mozilla.org/ja/docs/Web/HTTP/Headers/Set-Cookie
 */
const writeCookie = (key, value, options) => {
	const encodedKey = encodeURIComponent(key);
	const encodedValue = encodeURIComponent(value);
	let cookieParam = `${encodedKey}=${encodedValue};`;

	for(const option in options){
			if(option === 'secure' && options[option]){
				cookieParam += 'Secure;';
			} else if(option === 'httpOnly' && options[option]){
				//console.log('HttpOnly');
				cookieParam += 'HttpOnly;';
			} else if(option === 'maxAge') {
				cookieParam += `max-age=${options[option]};`;
			} else {
				cookieParam += `${option}=${options[option]};`;
			}
	}
	document.cookie = cookieParam;
}

/**
 * キーからCookie情報を削除します。
 * @param {*} key キー
 */
 const deleteCookie = (key) => {
	document.cookie = `${key}=; max-age=0;`;
 }

module.exports = {
	getCookieInfoByKey,
	checkCookie,
	deleteCookie,
	writeCookie,
	DEFAULT_EXPIRATION_SECOND
}